import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { useSearchParams } from '../../hooks/useSearchParams';

// Made props optional for now in order to account for mocked items
import { jsx as _jsx } from "react/jsx-runtime";
export function StorefrontPaginator({
  currentPage,
  pageCount,
  onPageChange
}) {
  const params = useSearchParams();
  return /*#__PURE__*/_jsx(Paginator, {
    "data-test-id": "storefront-paginator",
    onPageChange: e => {
      params.set('page', e.currentTarget.value.toString());
      onPageChange === null || onPageChange === void 0 || onPageChange(e);
    },
    paddingBlock: "1000",
    pageCount: pageCount,
    page: currentPage
  });
}